export default [
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/change-password',
    component: () => import('@/views/ChangePassword.vue')
  },
]
